import { AutogenModelEdiReqdfldgroup, AutogenRowEdiReqdfldgroup } from "./autogen/AutogenModelEdiReqdfldgroup";

export class ModelEdiReqdfldgroup extends AutogenModelEdiReqdfldgroup<RowEdiReqdfldgroup> {
	constructor() {
		super(RowEdiReqdfldgroup);
	}
}

export class RowEdiReqdfldgroup extends AutogenRowEdiReqdfldgroup {
}